import { render } from "./describe.vue?vue&type=template&id=6d954f02&scoped=true"
const script = {}

import "./describe.vue?vue&type=style&index=0&id=6d954f02&lang=less&scoped=true"

import exportComponent from "/ssd/code/flow-business-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d954f02"]])

export default __exports__